import { createSlice } from '@reduxjs/toolkit';

export const servicesIaBalanceSlice = createSlice({
  name: 'servicesIaBalance',
  initialState: {
    balance_list: [],
    balance_active: null,
  },
  reducers: {
    setServicesIaBalanceListRedux: (state, { payload }) => {
      state.balance_list = payload;
    },
    setServicesIaBalanceActiveRedux: (state, { payload }) => {
      state.balance_active = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setServicesIaBalanceListRedux, setServicesIaBalanceActiveRedux } =
  servicesIaBalanceSlice.actions;
